import ko from 'knockout'
import { PriceChangeDisplay } from '@core/Components/PriceChangeDisplay'
import { Disposable } from '../../../../AppUtils/Framework/Disposable/Disposable'
import Guard from '../../../../AppUtils/Framework/Guard'
import type { BettingInformation } from '../../../Model/BettingInformation'
import type { ObservableStarter } from '../../../Model/Observables/ObservableStarter'

export interface Params {
  starter: ObservableStarter
  bettingInformation: BettingInformation
}

export class MultiSelectionPriceViewModel extends Disposable {
  public bettingInformation: BettingInformation
  public starter: ObservableStarter
  public isFixedOddsOn: ko.Observable<boolean>
  public shouldDisplayScratchedFixedOdds: ko.PureComputed<boolean>
  public shouldDisplaySuspendedFixedOdds: ko.PureComputed<boolean>
  public shouldDisplayWinFixedOdds: ko.PureComputed<boolean>
  public shouldDisplayPlaceFixedOdds: ko.PureComputed<boolean>
  public shouldDisplayStackedPrices: ko.PureComputed<boolean>
  public PriceChangeDisplay = PriceChangeDisplay

  constructor(params: Params) {
    super()

    Guard.notNull(params.starter)
    Guard.notNull(params.bettingInformation)

    this.starter = params.starter
    this.bettingInformation = params.bettingInformation
    this.isFixedOddsOn = ko.observable<boolean>(false)

    this.shouldDisplayScratchedFixedOdds = ko.pureComputed<boolean>(
      () => this.starter.hasFixedOdds() && this.starter.fixedOddsStarterInfo.isScratched()
    )
    this.shouldDisplaySuspendedFixedOdds = ko.pureComputed<boolean>(
      () =>
        this.starter.hasFixedOdds() &&
        !this.starter.fixedOddsStarterInfo.isScratched() &&
        !this.starter.fixedOddsStarterInfo.hasWinDividend()
    )
    this.shouldDisplayWinFixedOdds = ko.pureComputed<boolean>(
      () =>
        this.starter.hasFixedOdds() &&
        !this.starter.fixedOddsStarterInfo.isScratched() &&
        this.starter.fixedOddsStarterInfo.hasWinDividend()
    )
    this.shouldDisplayPlaceFixedOdds = ko.pureComputed<boolean>(
      () =>
        this.starter.hasFixedOdds() &&
        !this.starter.fixedOddsStarterInfo.isScratched() &&
        this.starter.fixedOddsStarterInfo.hasWinDividend() &&
        this.starter.fixedOddsStarterInfo.hasPlacePool()
    )
    this.shouldDisplayStackedPrices = ko.pureComputed<boolean>(
      () =>
        this.bettingInformation.selectedBetType().isExacta() ||
        this.bettingInformation.selectedBetType().isQuinella() ||
        this.bettingInformation.rovingBanker() ||
        this.bettingInformation.isBoxed() ||
        this.bettingInformation.selectedBetType().isMultiLegType() ||
        this.bettingInformation.selectedBetType().isAllUp()
    )

    this.registerEventHandlers()
  }

  private registerEventHandlers() {
    this.safeSubscribe('fixed-odds-display-state-changed', (isOn: boolean) => {
      this.isFixedOddsOn(isOn)
    })
  }
}
